import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root'); // Defina o elemento principal da aplicação para acessibilidade

const ProjectModal = ({ isOpen, onRequestClose, project }) => {
  if (!project) return null;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Detalhes do Projeto"
      className="modal-content"
      overlayClassName="modal-overlay"
    >
      <div className="flex flex-col md:flex-row">
        <div className="flex flex-col w-full md:w-1/2 mb-4 md:mb-0 md:mr-4">
          <img src="/images/systems/mobiuniconn1.png" alt="MobiUniconn 1" className="w-full h-auto object-cover mb-4 max-h-96" />
          <img src="/images/systems/mobiuniconn2.png" alt="MobiUniconn 2" className="w-full h-auto object-cover max-h-96" />
        </div>
        <div className="text-left w-full md:w-1/2">
          <h2 className="text-2xl font-bold mb-4">{project.title}</h2>
          <p className="mb-4">{project.description}</p>
          <p>
            <strong>MobiUniconn</strong> é uma plataforma avançada de <strong>rastreamento por GPS</strong> e <strong>gestão financeira</strong>. Com o MobiUniconn, você tem total controle sobre o estoque de chips, rastreadores, veículos e clientes, tudo em um só lugar. Nossa solução inclui um aplicativo personalizado com a sua logomarca, oferecendo uma experiência exclusiva para seus clientes.
          </p>
          <p>
            Além disso, a plataforma conta com um módulo financeiro completo, onde é possível gerar cobranças e realizar pagamentos diretamente pelo aplicativo. Seja para gerenciar sua frota ou controlar as finanças, o MobiUniconn é a solução ideal para maximizar a eficiência e a produtividade do seu negócio.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ProjectModal;
